// extracted by mini-css-extract-plugin
export default {"mobileModal":"styles_mobileModal__W94sS","fullView":"styles_fullView__UQioX","shimmer":"styles_shimmer__njvIx"};